"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Zip = require('./zip');

var _require = require('./utils'),
    getBase64FromBuffer = _require.getBase64FromBuffer,
    Uint8ArrayToString = _require.Uint8ArrayToString;

var AabManifestName = /base\/manifest\/AndroidManifest\.xml/i;
var AabResourceName = /^base\/resources\.pb$/i;
var AabSdkVersion = /^base\/assets\/channel_msg\.txt/;

var ManifestXmlParser = require('./xml-parser/manifest'); // const ResourceFinder = require('./resource-finder')


var AabSdkConf = /^(base_assets|base)\/assets\/herosdkcfg\.xml$/; // const AabSdkConfAssets = /^base_assets\/assets\/herosdkcfg\.xml$/ // wtf
// const fastparser = require('fast-xml-parser')

var AabParser = /*#__PURE__*/function (_Zip) {
  _inherits(AabParser, _Zip);

  var _super = _createSuper(AabParser);

  /**
   * parser for parsing .aab file
   * @param {String | File | Blob} file // file's path in Node, instance of File or Blob in Browser
   */
  function AabParser(file) {
    var _this;

    _classCallCheck(this, AabParser);

    _this = _super.call(this, file);

    if (!(_assertThisInitialized(_this) instanceof AabParser)) {
      return _possibleConstructorReturn(_this, new AabParser(file));
    }

    return _this;
  }

  _createClass(AabParser, [{
    key: "getSdkPackConf",
    value: function getSdkPackConf(apkInfo, resolve, reject) {
      this.getEntries([AabSdkVersion, AabSdkConf]).then(function (buffers) {
        console.log(buffers);
        var info = {};

        if (buffers[AabSdkVersion]) {
          info = Uint8ArrayToString(buffers[AabSdkVersion]);

          if (info) {
            var obj = JSON.parse(info);
            apkInfo.SdkVersion = obj.sdkVersionName;
          }
        }

        if (buffers[AabSdkConf]) {
          info = Uint8ArrayToString(buffers[AabSdkConf]);
          var pidReg = /(?:<string name="_hu_pid_">)(\w+)(?:<\/string>)/g;

          if (info) {
            apkInfo.SdkConfKey = info;

            try {
              apkInfo.productId = pidReg.exec(info)[1] || '';
            } catch (err) {}
          }
        }

        resolve(apkInfo);
      })["catch"](function (e) {
        reject(e);
      });
    }
  }, {
    key: "parse",
    value: function parse() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.getEntries([AabManifestName, AabResourceName]).then(function (buffers) {
          // console.log(buffers)
          if (!buffers[AabManifestName]) {
            throw new Error('AabAndroidManifest.xml can\'t be found.');
          } // this._parseManifest(buffers[AabManifestName])


          var info = Uint8ArrayToString(buffers[AabManifestName]).replace(/[\t\n\u0000-\u0008\u000A-\u001F\u0100-\uFFFF\)\(]/g, ' ');
          var apkInfo = {
            application: {}
          }; // console.log(info)

          var versionCodeReg = /versionCode\s+\d+/g;
          var versionNameReg = /versionName\s+\d+(\.\d+)*/g;
          var packageNameReg = /package\s+(\))?[a-zA-Z]+[0-9a-zA-Z_]*(\.[a-zA-Z]+[0-9a-zA-Z_]*)*/g;
          var iconReg = /icon\s+(\w:\\)?@?(\w*\/)+(\w*)+/g; // var vCoderes = info.match(versionCodeReg)

          apkInfo.versionCode = _this2._getRegResult(info, versionCodeReg, /\d+/g);
          apkInfo.versionName = _this2._getRegResult(info, versionNameReg, /\d+(\.\d+)*/g);
          apkInfo["package"] = _this2._getRegResult(info, packageNameReg, /[a-zA-Z]+[0-9a-zA-Z_]*(\.[a-zA-Z]+[0-9a-zA-Z_]*)+/g);

          var iconTarget = _this2._getRegResult(info, iconReg, /(\w:\\)?@?(\w*\/)+(\w*)+/g);

          var iconArrParse = iconTarget && iconTarget.split('/');
          apkInfo.application.icon = iconTarget;
          var resourceInfo = Uint8ArrayToString(buffers[AabResourceName]).replace(/[\t\n\u0000-\u0008\u000A-\u001F\u0100-\uFFFF]/g, ' ');
          var appNameReg = /app_name(\s+[\w]*)*"\s+\w*/g;
          var appNameMatch = resourceInfo.match(appNameReg);

          if (appNameMatch && appNameMatch.length) {
            apkInfo.application.label = appNameMatch[0].replace(/\s/g, '').split('"')[1];
          } // find icon path and parse icon
          // const iconPath = findApkIconPath(apkInfo)


          var iconName = iconArrParse[iconArrParse.length - 1];
          var iconPathReg = new RegExp(".+\\/".concat(iconName, ".png"), 'g');

          if (iconName) {
            _this2.getEntry(iconPathReg).then(function (iconBuffer) {
              apkInfo.icon = getBase64FromBuffer(iconBuffer);

              _this2.getSdkPackConf(apkInfo, resolve, reject);
            })["catch"](function (e) {
              reject(e);
            });
          } else {
            apkInfo.icon = null;

            _this2.getSdkPackConf(apkInfo, resolve, reject);
          } // }

        })["catch"](function (e) {
          reject(e);
        });
      });
    }
    /**
     * Parse manifest
     * @param {Buffer} buffer // manifest file's buffer
     */

  }, {
    key: "_parseManifest",
    value: function _parseManifest(buffer) {
      try {
        var parser = new ManifestXmlParser(buffer, {
          ignore: ['application.activity', 'application.service', 'application.receiver', 'application.provider', 'permission-group'],
          debug: true
        });
        return parser.parse();
      } catch (e) {
        throw new Error('Parse AndroidManifest.xml error: ', e);
      }
    }
    /**
     * Parse resourceMap
     * @param {Buffer} buffer // resourceMap file's buffer
     */
    // _parseResourceMap (buffer) {
    //   try {
    //     return new ResourceFinder().processResourceTable(buffer)
    //   } catch (e) {
    //     throw new Error('Parser resources.arsc error: ' + e)
    //   }
    // }

  }, {
    key: "_getRegResult",
    value: function _getRegResult(info, reg1, reg2) {
      var matchRest = info.match(reg1); // console.log(re)

      if (matchRest != null) {
        if (matchRest[0] !== '') {
          var res1 = matchRest[0].match(reg2);

          if (res1[0] !== '') {
            return res1[0];
          }
        }
      }

      return '';
    }
  }]);

  return AabParser;
}(Zip);

module.exports = AabParser;